import { ApiQueryKeys } from 'api/common/queryKeys'
import { useQueries } from 'react-query'
import { GetPermitTransactionV2ResponseBodyDTO } from '@ketch-com/figurehead'
import { fetchMultiplePermitTransactions } from 'api/auditLogs/fetchers/fetchMultiplePermitTransactions'

export const useMultiplePermitTransactions = (transactionIdArray: string[]) => {
  const queries = transactionIdArray.length
    ? transactionIdArray.map(transactionId => {
        return {
          queryKey: [ApiQueryKeys.auditLogsMultiplePermitTransactions, { transactionId }],
          queryFn: fetchMultiplePermitTransactions,
        }
      })
    : []

  const results = useQueries<GetPermitTransactionV2ResponseBodyDTO[]>(queries as any)

  // Using "as any" here because there's an open issue about how typing useQueries from react-query is challenging.
  // Issue Link: https://github.com/tannerlinsley/react-query/issues/1675
  const transactions = results.reduce<GetPermitTransactionV2ResponseBodyDTO[]>((acc, r) => {
    if (r.status === 'success') {
      acc.push((r.data as any)?.data as GetPermitTransactionV2ResponseBodyDTO)
    }
    return acc
  }, [])

  return {
    data: transactions,
    isLoading: results.some(r => r.isLoading),
    isFetched: results.every(r => r.isFetched),
    isFetching: results.some(r => r.isFetching),
    isRefetching: results.some(r => r.isRefetching),
    refetch: () => Promise.all(results.map(r => r.refetch())),
  }
}
